import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[5/7] w-full overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title}免费韩国漫画封面`}
          title={`${comic.title} 韩漫推荐`}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
        {comic.hot && (
          <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-2 py-0.5 text-[10px] font-bold text-background-50">
            热门
          </span>
        )}
        <span
          className={`absolute right-2 top-2 rounded-md px-2 py-0.5 text-[10px] font-bold ${
            comic.status === "完结"
              ? "bg-accent-500 text-background-50"
              : "bg-background-950/70 text-background-50"
          }`}
        >
          {comic.status}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3.5">
        <h3 className="line-clamp-1 text-sm font-bold text-foreground-950 group-hover:text-primary-500">
          {comic.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 text-xs leading-5 text-foreground-600">
          {comic.description}
        </p>
        <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3">
          <span className="flex items-center gap-1 text-xs text-foreground-600">
            <i className="ri-star-fill text-secondary-500"></i>
            <span className="font-bold text-foreground-900">{comic.rating.toFixed(1)}</span>
          </span>
          <span className="flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-eye-line"></i>
            {comic.views}
          </span>
        </div>
      </div>
    </Link>
  );
}